export enum ArticleQueryKeys {
  getAllArticle = "get-all-article",
  getSingleArticle = "get-single-article",
}
